module.exports = __webpack_public_path__ + "res/15-img_flip_counter.420ef78df6b9045be20d26ffafdfacba.png";